import { createAction } from '@reduxjs/toolkit';
import type { PaginationState } from '../types';

export const deepTagReportProductPaginationActions = {
  updatePagination: createAction<Partial<PaginationState>>(
    'DeepTagReportProductPagination/UpdatePagination'
  ),
  resetPagination: createAction('DeepTagReportProductPagination/ResetPagination'),
};
